<template>
  <div>


    <h3 class="font-w300 push-10 align-center">{{descriptionTitle[actualLanguage]}}</h3>
    <h5 class="font-w300 push-10 align-center">{{description01[actualLanguage]}}</h5>
    <h5 class="font-w300 push-10 align-center">{{description02[actualLanguage]}}</h5>




     <div v-if="flagDisplayPanes" class="row">  

            <div class="block">
                <ul class="nav nav-tabs nav-tabs-alt" data-toggle="tabs">
                    <li v-bind:class="tabTitleClass[0]">
                        <a @click="switchPane(0)">{{onglet01[actualLanguage]}}</a>
                    </li>
                    <li v-bind:class="tabTitleClass[1]">
                        <a @click="switchPane(1)">{{onglet02[actualLanguage]}}</a>
                    </li>
                </ul>
                <div class="block-content tab-content">

                    <div  v-bind:class="tabContentClass[0]">
                        

                        <div v-for="(tab, indexTab) in dashboardData.tabs" class="col-xs-12 col-md-12">

                          <h2 class="font-w300 push-15"> {{labelTab[actualLanguage]}} {{indexTab+1}}</h2>

                          <div class="col-sm-12 col-md-6 col-lg-6 push">
                            <label for="register4-firstname">{{ labelTabName[actualLanguage] }}</label>
                            <input class="form-control" type="text" v-model="dashboardData.tabs[indexTab].tabName" placeholder="Nom Onglet/Tab name">
                          </div> 

                          <!--  ===================================================  -->
                          <!--              Section list                             -->
                          <!--  ===================================================  -->
                          <div v-for="(section, indexSection) in dashboardData.tabs[indexTab].sections" class="col-xs-12 col-md-12">
                            <div class="block block-bordered">
                              <div class="row">
                                <div class="block-content">
                                  <h3 class="font-w300 push-15"> {{labelTab[actualLanguage]}} {{indexTab+1}} : Section {{indexSection+1}}</h3>

                                  <div class="col-sm-12 col-md-12 push">
                                    <div class="col-sm-12 col-md-6 col-lg-3">
                                      <label  for="example-multiple-select">{{ labelSectionSize[actualLanguage] }}</label>
                                      <select class="form-control" v-model=section.size size="1">
                                          <option value="Small">Small (1/3)</option>
                                          <option value="Medium">Medium (1/2)</option>
                                          <option value="Large">Large</option>
                                      </select>
                                    </div>
                                  </div> 

                                  <!--  ===================================================  -->
                                  <!--              Configuration des tuiles                 -->
                                  <!--  ===================================================  -->
                                  
                                  <h4 class="font-w300 push-15">{{titleTile[actualLanguage]}}</h4>

                                  <div class="form-group">


                                    <div v-for="(tile,indexTile) in section.tiles" class="col-xs-12 col-md-12">

                                      <div class="block block-bordered block-themed block-content">
                                        <div class="row">
                                        <h4 class="font-w300 push-15"> {{titleTile[actualLanguage]}} {{indexTile+1}}</h4>
                                          <div class="col-sm-12">

                                            <div class="col-sm-12 col-md-6 col-lg-3">
                                              <label for="register4-firstname">{{ labelTileLabel[actualLanguage] }}</label>
                                              <input class="form-control" type="text" v-model="tile.label" placeholder="Nom/Name">
                                            </div>


                                            <div class="col-sm-12 col-md-6 col-lg-3">
                                              <label  for="example-multiple-select">{{ labelTileAgregation[actualLanguage] }}</label>
                                              <select class="form-control" v-model=tile.agregation size="1">
                                                  <option value="Sum">Somme/Sum</option>
                                                  <option value="Min">Minimum</option>
                                                  <option value="Max">Maximum</option>
                                                  <option value="Avr">Moyenne/Average</option>
                                                  <option value="Last">Dernière mesure/Last measure</option>
                                              </select>
                                            </div>


                                            <div class="col-sm-12 col-md-6 col-lg-3">
                                              <label  for="example-multiple-select">{{ labelTileIcon[actualLanguage] }}</label>
                                              <select class="form-control" v-model=tile.icon size="1">
                                                  <option value="fa fa-plus"><i class="fa fa-plus fa-1x push-5-r "></i></option>
                                                  <option value="Medium">Medium (1/2)</option>
                                                  <option value="Large">Large</option>
                                              </select>
                                            </div>

                                            <div class="col-sm-12 col-md-6 col-lg-6 push">
                                              <label for="register4-firstname">{{ labelTileLabelIcon[actualLanguage] }} </label>
                                              <select class="form-control" v-model=tile.favIcon size="1">
                                                  <option v-for="icon in faIconList" v-bind:value="icon.favIcon">{{icon.label}}</option>
                                              </select>
                                            </div>



                                            <div class="col-sm-12 col-md-6 col-lg-3">
                                              <h4 class="font-w300 push-15"> {{titleTile[actualLanguage]}} {{indexTile+1}}</h4>
                                            </div>                                           

                                            <div class="col-sm-12">
                                              <custom-dashboard-tile  :tile="tile" ></custom-dashboard-tile>
                                            </div> 




                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                  <!-- Tile Section end  -->

                                  <div class="col-sm-12 col-md-12">
                                    <p><button @click="addTileToSection(indexTab,indexSection)" type="button" class="btn btn-critical align-left" name="button">
                                      <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddTile[actualLanguage] }}</span></button></p>
                                  </div>


                                  <!--  ===================================================  -->
                                  <!--              Configuration des graphique              -->
                                  <!--  ===================================================  -->
                                  <h4 class="font-w300 push-15">{{titleGraph[actualLanguage]}}</h4>


                                  <div class="col-sm-12 col-md-12">
                                    <p><button @click="addGraphToSection(indexTab, indexSection)" type="button" class="btn btn-critical align-left" name="button">
                                      <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddGraph[actualLanguage] }}</span></button></p>
                                  </div>

                                  <div class="col-sm-12 col-md-3">
                                    <p><button @click="deleteThisSection(indexTab,indexSection)" type="button" class="btn btn-danger align-left" name="button">
                                      <span><i class="fa fa-trash fa-1x push-5-r "></i>{{ labelButtonDeleteSection[actualLanguage] }}</span></button></p>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>

                          <div class="col-sm-12 col-md-12 push">
                            <p><button @click="addSectionToDashboard(indexTab)" type="button" class="btn btn-success align-left" name="button">
                              <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddSection[actualLanguage] }}</span></button></p>
                          </div>

                          <div class="col-sm-12 col-md-12">
                            <p><button @click="deleteTabToDashboard(indexTab)" type="button" class="btn btn-danger align-left" name="button">
                              <span><i class="fa fa-trash fa-1x push-5-r "></i>{{ labelButtonDeleteTab[actualLanguage] }}</span></button></p>
                          </div>

                        </div>





                    </div>

                    <div class="col-sm-12 col-md-12">
                      <p><button @click="addTabToDashboard()" type="button" class="btn btn-success align-left" name="button">
                        <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddTab[actualLanguage] }}</span></button></p>
                    </div>

{{dashboardData}}

                    <div  v-bind:class="tabContentClass[1]">
                        <h3 class="font-w300 push-15"> Preview</h3>
                    </div>

                </div>
            </div>

    </div>





  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapActions,mapGetters} from 'vuex'
import Spinner from '../../components/Spinner.vue'

import CustomDashboardTile from '../custom_dashboard/SubComponent/CustomDashboardTileV1p00.vue'
import favIconList from './FavIconList.js'

export default {
  //props: ['channelIndex'],
  components: {
    Spinner,
    CustomDashboardTile,

  },
  data() {
    return {    
      actualLanguage : "FR",
      dashboardData : {version:'1P00',
                      tabs:[],
                      itemCount:'0'},
      maxItemCount : '4',
      tabTitleClass : ['active',''],
      tabContentClass : ['tab-pane active','tab-pane'],
      flagDisplayPanes : true,

      descriptionTitle:{FR: "Configuration du menu <Mon Dashboard>",
                     EN: "<My Dashboard> configuration menu"},
      description01:{FR: "Cette section de configuration vous permet de configurer l'affichage du menu 'Mon Dashboard' (boutons du haut de la page).",
                     EN: "This configuration section allows you to configure the display of the 'My Dashboard' menu (buttons at the top of the page)."},
      description02:{FR: "Utilisez l'onglet 'Configuration' pour ajouter les éléments souhaités pour votre Dashboard et utiliser l'onglet 'Prévisualisation' pour voir le résultat.",
                     EN: "Use the 'Configuration' tab to add the desired elements for your Dashboard and use the 'Preview' tab to see the result."},
 
      messageMaxItemCountReach:{FR: "Vous avez atteint le nombre maximal d'item pour votre Dashboard, pour augmenter cette limite, vous devez modifier votre forfait (via la section Mon Profile).",
                                EN: "You have reached the maximum number of items for your Dashboard, to increase this limit, you must modify your package (via the My Profile section)."},

      onglet01 :{FR: "Configuration",EN: "Configuration"},
      onglet02 : {FR: "Prévisualisation",EN: "Preview"},

      labelTab:{FR: "Onglet", EN: 'Tab'},
      labelTabName:{FR: "Nom d'onglet", EN: 'Tab name'},
      labelButtonAddTab:{FR: "Ajouter un onglet", EN: 'Add tab'},
      labelButtonDeleteTab:{FR: "Supprimer cet onglet", EN: 'Delete this tab'},

      labelButtonAddSection:{FR: "Ajouter une section", EN: 'Add section'},
      labelSectionSize:{FR: "Dimension de la section", EN: 'Section size'},


      titleTile : {FR: "Tuile", EN: 'Tile'},
      labelButtonAddTile:{FR: "Ajouter une tuile", EN: 'Add tile'},
      labelTileLabel : {FR: "Étiquette", EN: 'Label'},
      labelTileAgregation : {FR: "Agregation", EN: 'Agregation'},
      labelTileIcon : {FR: "Icone", EN: 'Icon'},

      titleGraph : {FR: "Graphique", EN: 'Graph'},
      labelButtonAddGraph:{FR: "Ajouter un graphique", EN: 'Add graph'},
      labelButtonDeleteSection:{FR: "Supprimer cette section", EN: 'Delete this section'},

    
    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','groupArborescence','actualBundle','dashboardFlags']),
  },

  methods: {

    switchPane(index){
      for(var m=0;m<this.tabTitleClass.length;m++){
        this.tabTitleClass[m]=''
        this.tabContentClass[m]='tab-pane'
      }
      this.tabTitleClass[index]='active'
      this.tabContentClass[index]='tab-pane active'
      this.flagDisplayPanes = false
      this.$nextTick(() => {this.flagDisplayPanes = true});
    },


    validateItemCount(){
      let ActualFloatCount = parseInt(this.dashboardData.itemCount)
      ActualFloatCount += 1
      if(ActualFloatCount >= parseInt(this.maxItemCount)){
        window.alert(this.messageMaxItemCountReach[this.actualLanguage] )
        return false
      }else{
        this.dashboardData.itemCount = ActualFloatCount.toString()
        return true
      }
    },

    addTabToDashboard(){
      this.dashboardData.tabs.push(
        {
          tabName:'Nom Onglet/Tab Name',
          sections:[]}
          )
    },

    deleteTabToDashboard(index){
      this.dashboardData.tabs.pop(index)
    },

    addSectionToDashboard(index){
      this.dashboardData.tabs[index].sections.push(
        {
          size:'Large',
          tiles:[],
          graphs:[]}
          )
    },

    addTileToSection(index1,index2){
      if (this.validateItemCount()){
        this.dashboardData.tabs[index1].sections[index2].tiles.push(
          {
          label : 'Étiquette/Label',
          width : 'Large',
          favIcon : '',
          sufix : '',
          value : Math.floor(Math.random()*10),
          decimal:"2",
          agregation : 'Sum',
          linkedChannels : [],
          colorConditions : [{colorBackground : "#46c37b",
                    minValue:-100000,
                    maxValue:100000,
                    customColorFlag:false,
                    customColorRed:125,
                    customColorGreen:125,
                    customColorBlue:125}]
          }
      )}
    },
    addConditionalColor(index1,index2,index3){
      this.dashboardData.tabs[index1].sections[index2].tiles[index3].push({
                            colorBackground : "#46c37b",
                            minValue:-100000,
                            maxValue:100000,
                            customColorFlag:false,
                            customColorRed:125,
                            customColorGreen:125,
                            customColorBlue:125
      })
    },


    addGraphToSection(index1,index2){
      if (this.validateItemCount()){
      this.dashboardData.tabs[index1].sections[index2].graphs.push(
        'allo'
      )}
    },

    deleteThisSection(index1,index2){
      this.dashboardData.tabs[index1].sections.pop(index2)
    }

  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}


  },


}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConfigCustomDashboardV1p00.vue?12ed41e4